import React from 'react';

export default class Isometria extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;
    const video = '289324683';
    return(
      <div>
        <div>Depois de executar as repetições de uma série, você vai sustentar a carga sem gerar movimento, o pelo tempo sugerido na planilha, à frente do exercício (geralmente são 10 segundos). Fazer isso em todas as séries do exercício proposto.<br />
Veja o exemplo no vídeo abaixo:</div>
          <iframe
            className='vimeo-video'
            src={`https://player.vimeo.com/video/${video}?autoplay=1&loop=1&autopause=0`}
            height="300"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen="true">
          </iframe>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Isometria.js